import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Header from '../header/header';
import Footer from '../footer/footer';
import { useMenu } from '../../context/MenuContext';
import Collapse from '@mui/material/Collapse';
import Mobile from './menu/mobile';
import { HelmetDatoCms } from "gatsby-source-datocms"

const Layout = ({ children, hasSplash = false, isMusingDetail, seo }) => {
  const { isMenuOpen, toggleMenu } = useMenu();
  const [showSplash, setShowSplash] = useState(false);

  const data = useStaticQuery(graphql`
    query {
      datoCmsHeader {
        menu {
          ... on DatoCmsAnchorLink {
            title
            anchor
          }
        }
      }
      datoCmsSite {
        faviconMetaTags {
          ...GatsbyDatoCmsFaviconMetaTags
        }
      }      
    }
  `);

  const links = data.datoCmsHeader.menu;
  return (
    <div className={'layout'}>
      <HelmetDatoCms seo={seo} favicon={data.datoCmsSite.faviconMetaTags}>
        <html lang="en" />
      </HelmetDatoCms>
      <Collapse in={isMenuOpen}>
        <Mobile links={links} />
      </Collapse>
      <Header links={links} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
